module.exports = __webpack_public_path__ + "img/section2Logo3.44ba5423.png";